import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, API } from "@/lib/api";
import { UploadCloud, Loader2, ImageIcon } from "lucide-react";

export const ImageUpload = ({ value, onChange, testid = "image-upload" }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(`${API}/files/${data.path}`);
      toast.success("Photo uploaded 💛");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed.");
    } finally { setBusy(false); }
  };

  let buttonLabel = "Upload product photo";
  if (busy) buttonLabel = "Uploading…";
  else if (value) buttonLabel = "Replace photo";

  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-3">
        <div className="h-16 w-16 rounded-lg bg-[#F2EFEB] border border-[#E5DFD5] overflow-hidden flex items-center justify-center shrink-0">
          {value ? <img src={value} alt="preview" className="h-full w-full object-cover" /> : <ImageIcon className="h-6 w-6 text-[#D1CCC5]" />}
        </div>
        <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${testid}-btn`}
          className="flex-1 inline-flex items-center justify-center gap-2 border border-dashed border-[#8E9A86] text-[#3A3632] rounded-lg py-3 text-sm font-medium hover:bg-[#FAF7F2] transition-colors disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UploadCloud className="h-4 w-4" />}
          {buttonLabel}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])} data-testid={`${testid}-input`} />
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="…or paste an image URL"
        className="ai mt-2" data-testid={`${testid}-url`} />
    </div>
  );
};
